<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">account_circle</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">

                                            <div class="col-xl-3 col-lg-3 col-md-3 col-xs-6 overflow-hidden">
                                                <center>

                                                    <avatar-cropper
                                                      @submit="submitAvatar"
                                                      @uploading="uploadAvatar"
                                                      :labels="{ 'submit': 'Ok', 'cancel': 'Cancelar'}"
                                                      :upload-handler="uploadAvatar"
                                                      trigger="#avatar-imagem" />

                                                    <div class="avatar-wrapper margin-top-0">
                                                        <div class="img" id="avatar-imagem" v-if="form.imagem" :style="{'background-image': 'url(' + form.imagem + ')'}"></div>
                                                    </div>

                                                </center>
<!--                                                 <center>
                                                    <div class="avatar-wrapper margin-top-0">
                                                        <div class="img" v-if="form.imagem" :style="{'background-image': 'url(' + form.imagem + ')'}"></div>
                                                        <div class="upload-button"></div>
                                                        <input class="file-upload" type="file" name="imagem" @change="getBase64Imagem" accept="image/*"/>
                                                    </div>
                                                </center> -->
                                            </div>
                                            <div class="col-xs-6">
                        
                                                <router-link :to="{'name': 'AlterarSenha'}" class="button gray small  block-mobile margin-bottom-5">
                                                    <i class="material-icons">lock</i>
                                                    Alterar senha
                                                </router-link>
                                                <router-link :to="{'name': 'Sintomas'}" class="button gray small  block-mobile margin-bottom-5" v-if="$root.user.tipo == 'contratante'">
                                                    <i class="material-icons">check_box</i>
                                                    Meus sintomas
                                                </router-link>
                                                <a class="button gray small  block-mobile margin-bottom-5" v-if="$root.user.tipo == 'contratante'">
                                                    <i class="material-icons">cloud_download</i>
                                                    Meus dados
                                                </a>
                                                <a v-on:click="$root.logout()" class="button gray small  block-mobile margin-bottom-5">
                                                    <i class="material-icons">power_settings_new</i>
                                                    Sair
                                                </a>                                                
                       
                                            </div>
                                            <div class="col-xl-9 col-lg-7">
                                                <div class="row">

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>Nome completo</h5>
                                                            <input type="text" class="with-border margin-bottom-5" placeholder="Informe seu nome completo..." v-model="form.nome">
                                                            <small v-if="$root.user.tipo != 'contratante'" style="line-height: 120%;" class="block margin-bottom-10">Nível: {{userTipo}}</small>
                                                            <div v-if="$root.user.tipo == 'contratante'" style="" class="margin-bottom-10"></div>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>E-mail</h5>
                                                            <input type="email" class="with-border" placeholder="Informe seu e-mail aqui" v-model="form.email">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-7 col-md-5 col-lg-7">
                                                        <div class="submit-field">
                                                            <h5>Telefone</h5>
                                                            <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-xs-7 col-md-4">
                                                        <div class="submit-field">
                                                            <h5>CPF</h5>
                                                            <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" readonly="" class="with-border" v-model="form.doc" placeholder="000.000.000-00"/>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-12 col-xs-12 col-md-12" v-if="$root.user.tipo == 'profissional'">
                                                        <div class="submit-field margin-bottom-20">
                                                            <h5>Registro de classe</h5>
                                                            <input type="text" class="with-border margin-bottom-5" placeholder="...." v-model="form.descricao">
                                                            <small style="line-height: 120%;" class="block">Será mostrado aos pacientes quando visualizarem seu perfil.</small>
                                                        </div>
                                                    </div>                                
                                                    <div class="col-xl-12 col-xs-12 col-md-12" v-if="$root.user.tipo == 'profissional'">
                                                        <div class="submit-field margin-bottom-20">
                                                            <h5>Texto sobre dias e horários de atendimento</h5>
                                                            <textarea class="with-border margin-bottom-5" style="min-height: 70px;" v-model="form.horarioAtendimento" name="horarioAtendimento"></textarea>
                                                            <small style="line-height: 120%;" class="block">Será mostrado aos pacientes quando visualizarem seu perfil.</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-xs-6 col-md-3 disabled" v-if="$root.user.tipo != 'contratante'">
                                                        <div class="submit-field margin-bottom-20">
                                                            <h5>Código no Tasy</h5>
                                                            <input type="number" class="with-border margin-bottom-5" readonly="" placeholder=".." disabled="" v-model="$root.user.codigoIntegracao">
                                                            <small style="line-height: 120%;" class="block">Código do usuário no Tasy, campo necessário para integração.</small>
                                                        </div>
                                                    </div>    

                                                    <div class="col-xl-4 col-xs-7 col-md-4" v-if="$root.user.tipo == 'contratante'">
                                                        <div class="submit-field">
                                                            <h5>Data de nascimento</h5>
                                                            <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="with-border" readonly="" autocomplete="new-password" v-model="form.dataNascimento" placeholder="___ /____ /_____" required />
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-12 col-xs-12" v-if="$root.user.tipo == 'contratante'">
                                                        <div class="submit-field">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="enviarEmailSMS" v-model="form.enviarEmailSMS" true-value="1" false-value="0">
                                                                <label for="enviarEmailSMS"><span class="checkbox-icon"></span>  Desejo receber notificações<br>por <b>e-mail</b> e <b>SMS</b>.</label>
                                                            </div>                                                    
                                                        </div>
                                                    </div>                                                    


                                                    <!-- Button -->
                                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                        <button type="submit" class="button big green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            Salvar alterações
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'Conta',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar,
        'AvatarCropper': AvatarCropper
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "doc":              self.$root.user.doc,
                "imagem":           self.$root.user.imagem,
                "codigoIntegracao": self.$root.user.codigoIntegracao,
                "enviarEmailSMS":   self.$root.user.enviarEmailSMS,
                "descricao":        self.$root.user.descricao,
                "categorias":       self.$root.user.categorias,
                "horarioAtendimento":self.$root.user.horarioAtendimento,
                "dataNascimento":   self.$root.user.dataNascimento.split("-")[2] + "/" + self.$root.user.dataNascimento.split("-")[1] + "/" + self.$root.user.dataNascimento.split("-")[0],
                "telefone":         self.$root.user.telefone
            }            
        }
    },
    computed: {
        userTipo: function(){
            var self = this;
            var tipo = "";
            switch(self.$root.user.tipo) {
                case "admin":
                    tipo = "Administrador";
                    break;

                case "profissional":
                    tipo = "Profissional";
                    break;   

                case "marketing":
                    tipo = "Marketing";
                    break;

                case "contratante":
                    tipo = "Paciente";
                    break;                                     
            }
            return tipo;
        }
    },
    methods: {
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 1000, Infinity, 0.9, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            return true;
        },         
        // submitAvatar: function(e) {
        //     console.log("submitAvatar()", e)
        // },
        // uploadAvatar: function(e) {
        //     var self = this;
        //     console.log("uploadAvatar()", e)
        //     self.form.imagem = e.getCroppedCanvas().toDataURL();
        //     self.$forceUpdate();
        //     return true;
        // },          
        getBase64Imagem: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // console.log("result", result);
                        loading.hide();
                        self.form.imagem    = result;
                    });
                }); 
            }   
        },           
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/conta.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response.data.result)
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });                
                loading.hide();
                self.$root.setUser(response.data.result);
                alert(response.data.message);
                if (response.data.result) {
                    
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    mounted: function() {
        var self = this;
        console.log("user>", self.form)
        loading.hide();
        // $(".upload-button").on('click', function() {
        //     $(".file-upload").click();
        // });             
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button.gray {
        padding-top: 3px;
        padding-bottom: 3px;        
    }
</style>



// WEBPACK FOOTER //
// src/components/Conta.vue